import { Grid } from "@mui/material";
// import { useState } from "react";
import Button from "../../../components/Button/Button";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup.js";
import useStyles from "../styles";
import { Roles } from "../../../utils/DropDown.js";

const Renumeration = () => {
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={4}>
        <Grid item lg={3} md={4} sm={12} xs={12}>
          <div className="left-container">
            <h4>Renumeration Details</h4>
            <h6>View renumeration details of your employee.</h6>
            <div className={classes.downloadbutton}>
              <Button variant="primary" color="btndefault" buttonSize="full" buttonName="Download Resume" />
            </div>
          </div>
        </Grid>
        <Grid item lg={9} md={8} sm={12} xs={12}>
          <div className="right-container">
            <Grid container spacing={2} className={classes.profileform}>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Bank Name" name="" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup inputType="text" label="Account Number" name="" />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup inputType="text" label="Account Name" name="" />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup inputType="text" label="Salary" name="" />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup label="Role" children={
                  <select>
                    <option value="">---Select Role ---</option>
                    {Roles?.map((role) => {
                      return (
                        <option key={role.key}>{role?.text}</option>
                      );
                    })}
                  </select>
                }
                />
              </Grid>
            </Grid>
            <div className={classes.btnspace}>
              <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Save Changes" />
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
};
export default Renumeration;
